import {
  clearListFilters,
  readListFilters,
  writeListFilters,
} from "./listFilterStorage";
import { applicantsJobScope } from "./listFilterScopes";
import {
  mergeStageFilterWithOptions,
  readSavedStageFilter,
} from "./applicantsStageFilter";

/** @deprecated Legacy key — migrated to listFilterScopes on read. */
const LEGACY_APPLICANTS_KEY_PREFIX = "june:applicantsListFilters:v1:";

export const DEFAULT_MATCH_RATING_FILTER = [1, 2, 3, 4, 5, "No Rating"];

export const DEFAULT_REQUIRED_QUESTIONS_FILTER = ["MET", "UNRESOLVED", "NA"];

function parseSetLikeArray(value) {
  if (!Array.isArray(value)) return null;
  return value;
}

function normalizeSavedFilters(parsed) {
  const stage = parsed.stage || {};
  const state = parsed.state || {};

  return {
    statusFilter:
      typeof parsed.statusFilter === "string" ? parsed.statusFilter : "all",
    keywordSearchQuery:
      typeof parsed.keywordSearchQuery === "string"
        ? parsed.keywordSearchQuery
        : "",
    matchRatingFilter:
      parseSetLikeArray(parsed.matchRatingFilter) || DEFAULT_MATCH_RATING_FILTER,
    requiredQuestionsFilter:
      parseSetLikeArray(parsed.requiredQuestionsFilter) ||
      DEFAULT_REQUIRED_QUESTIONS_FILTER,
    showRejectedSection: Boolean(parsed.showRejectedSection),
    currentPage:
      typeof parsed.currentPage === "number" && parsed.currentPage >= 1
        ? parsed.currentPage
        : 1,
    sortField:
      typeof parsed.sortField === "string" ? parsed.sortField : null,
    sortDirection:
      parsed.sortDirection === "asc" || parsed.sortDirection === "desc"
        ? parsed.sortDirection
        : null,
    stage: {
      selected: Array.isArray(stage.selected) ? stage.selected : [],
      knownOptions: Array.isArray(stage.knownOptions) ? stage.knownOptions : [],
      stageUserClearedAll: Boolean(stage.stageUserClearedAll),
    },
    state: {
      selected: Array.isArray(state.selected) ? state.selected : [],
      knownOptions: Array.isArray(state.knownOptions) ? state.knownOptions : [],
      stateUserClearedAll: Boolean(state.stateUserClearedAll),
    },
  };
}

function readLegacyApplicantsFilters(jobId) {
  if (!jobId || typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(
      `${LEGACY_APPLICANTS_KEY_PREFIX}${jobId}`
    );
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      return normalizeSavedFilters(parsed);
    }
  } catch {
    return null;
  }
  return null;
}

export function readApplicantsListFilters(jobId) {
  const scope = applicantsJobScope(jobId);
  if (scope) {
    const unified = readListFilters(scope);
    if (unified) return normalizeSavedFilters(unified);
  }

  const legacyApplicants = readLegacyApplicantsFilters(jobId);
  if (legacyApplicants) return legacyApplicants;

  const legacyStage = readSavedStageFilter(jobId);
  if (!legacyStage) return null;

  return normalizeSavedFilters({
    stage: legacyStage,
  });
}

export function writeApplicantsListFilters(jobId, filters) {
  const scope = applicantsJobScope(jobId);
  if (scope) writeListFilters(scope, filters);
}

export function clearApplicantsListFilters(jobId) {
  const scope = applicantsJobScope(jobId);
  if (scope) clearListFilters(scope);
  if (jobId && typeof window !== "undefined") {
    try {
      window.localStorage.removeItem(`${LEGACY_APPLICANTS_KEY_PREFIX}${jobId}`);
    } catch {
      // ignore
    }
  }
}

export function mergeOptionSetFilter(
  saved,
  optionValues,
  userClearedAll,
  knownOptions
) {
  return mergeStageFilterWithOptions(
    saved?.selected,
    optionValues,
    userClearedAll,
    knownOptions
  );
}
